<template>
  <section class="catg-area pt-5">
    <div class="">
      <div class="row align-content-center" style="margin:auto">
        <!-- <h4 class="mb-5">設定メニュー</h4> -->
        <div class="col-sm-12 col-12 mb-4 p-0">
          <div class="navbar-wrapper">
            <div class="navbar">
              <router-link
                v-for="link in navbarLinks"
                :key="link.path"
                :to="link.path"
                class="navbar-item"
                :class="{ active: isActiveLink(link) }"
                :style="{ width: navbarItemWidth }"
              >
                {{ link.label }}
              </router-link>
            </div>
          </div>
        </div>
        <router-view></router-view>
      </div>
    </div>
  </section>
</template>

<script>
import ChangePassword from '@/components/auth/ChangePassword.vue';
//import Notification from '@/components/dashboard/applicants/Notification.vue';
// import OccupationOrder from '../components/dashboard/OccupationOrder.vue';
import OccupationList from '../components/dashboard/OccupationList.vue';
import { mapGetters, mapActions } from 'vuex';
export default {
  name: 'Setting',
  components: { ChangePassword /*, Notification*/, OccupationList },
  computed: {
    ...mapGetters({
      isReviewer: 'isCreateReviewUser',
      isAdmin: 'currentUserIsAdmin',
      currentUser: 'getCurrentUser',
    }),
    globalUser() {
      return true;
    },
    jdMatchingAuthority() {
      return this.currentUser && this.currentUser.jdMatchingAuthority;
    },
    navbarItemWidth() {
      return 'auto';
    },
    navbarLinks() {
      const links = [
        {
          path: '/setting/users',
          label: '企業内ユーザー確認',
          show: this.isAdmin,
        },
        {
          path: '/setting/review-list',
          label: 'リスト設定',
          show: this.isReviewer,
        },
        {
          path: '/setting/password',
          label: 'パスワード変更',
          show: this.globalUser,
        },
        {
          path: '/setting/system',
          label: 'その他システム設定',
          show: this.isReviewer,
        },
      ];
      return links.filter((link) => link.show);
    },
  },
  methods: {
    ...mapActions({
      loadCurrentUser: 'loadCurrentUser',
    }),
    isCurrentRoute(path) {
      return this.$route.path === path;
    },
    isActiveLink(link) {
      const currentPath = this.$route.path;
      return currentPath.startsWith(link.path);
    },
  },
  async mounted() {
    this.changeBodyToWhite();
    await this.loadCurrentUser();
    // console.log(this.navbarLinks);
    // const firstLink = this.navbarLinks[0];
    // if(this.$route.path === '/setting'){
    //   this.$router.push(firstLink);
    // }
  },
};
</script>
<style scoped>
h4 {
  color: #617776;
  font-weight: bold;
}
.mt-4,
.my-4 {
  margin-top: 6.5rem !important;
}

.navbar-wrapper {
  display: flex;
  justify-content: center;
  width: 100%;
  overflow: visible;
}

.navbar {
  display: flex;
  justify-content: center;
  padding: 0px !important;
  border-bottom: 1px solid black;
  position: relative;
  gap: 0px;
  min-width: fit-content;
  flex-wrap: nowrap;
}

.navbar-item {
  color: #3c3c3c;
  text-decoration: none;
  font-weight: 600;
  text-align: center;
  padding: 10px 127px;
  white-space: nowrap;
  position: relative;
  flex-shrink: 0;
}

.navbar-item:hover {
  border-bottom: 5px solid #036d6c;
  color: #036d6c;
}
.active {
  border-bottom: 5px solid #036d6c;
  color: #036d6c;
}
</style>

<style>
/* Make all buttons in Settings page rectangular with curved edges */
.catg-area button,
.catg-area a.btn,
.modal button,
.modal a.btn {
  border-radius: 4px !important;
}
</style>
